/** 1-based indices rendered for feedback star rating (modal + list). */
export const FEEDBACK_STAR_INDICES = [1, 2, 3, 4, 5] as const;

export const FEEDBACK_STAR_COUNT = FEEDBACK_STAR_INDICES.length;

/** Inclusive: filled stars at or above this level use success (green) in UI. */
export const FEEDBACK_STAR_GREEN_FROM = 4;
